import type { ProductCard } from "@itaas/pep-contracts";

const NON_PRODUCT_MODULES = new Set(["iam", "suite"]);

function productBySlug(products: ProductCard[], slug: string): ProductCard | undefined {
  return products.find((p) => p.slug === slug.trim().toLowerCase());
}

export function getTrialDaysForModule(products: ProductCard[], slug: string): number | null {
  const normalized = slug.trim().toLowerCase();
  if (NON_PRODUCT_MODULES.has(normalized)) return null;
  const product = productBySlug(products, normalized);
  if (!product?.trialDays || product.trialDays <= 0) return null;
  return product.trialDays;
}

export function resolveModuleTrialDays(
  products: ProductCard[],
  modules: string[],
): Record<string, number> {
  const out: Record<string, number> = {};
  for (const slug of modules) {
    const days = getTrialDaysForModule(products, slug);
    if (days) out[slug.trim().toLowerCase()] = days;
  }
  return out;
}

/** Durée affichée = maximum des périodes d'essai des produits sélectionnés. */
export function resolveTrialDays(products: ProductCard[], modules: string[]): number | null {
  const values = Object.values(resolveModuleTrialDays(products, modules));
  if (!values.length) return null;
  return Math.max(...values);
}

export function formatTrialDaysLabel(days: number | null, locale: "fr" | "en" = "fr"): string {
  if (!days || days <= 0) {
    return locale === "en" ? "Free trial" : "Essai gratuit";
  }
  return locale === "en" ? `Free trial ${days} days` : `Essai gratuit ${days} jours`;
}
